// extracted by mini-css-extract-plugin
export default {"news-card":"newsCard_news-card__lizTI","image":"newsCard_image__Jfjf6","added-on":"newsCard_added-on__vWXQo","title":"newsCard_title__PVnEh"};